import React from "react";
import AppRow from "src/commun/composants/grille/AppRow";
import AppCol from "src/commun/composants/grille/AppCol";
import { useAppText } from "src/commun/composants/AppText";
import EmailUpdate from "src/pages/infoperso/connexion/module/email/EmailUpdate";
import MobileUpdate from "src/pages/infoperso/connexion/module/mobile/MobileUpdate";
import PasswordUpdate from "src/pages/infoperso/connexion/module/password/PasswordUpdate";

export type InfoConnexionProps = {
  readOnly: boolean;
}

const InfoConnexion = ({ readOnly }: InfoConnexionProps) => {

  const { tString } = useAppText();
  return (
    <>
      <AppRow>
        <h2 className={"appTitle"}>{tString("compte.mon.profile.connexionSecurite.title")}</h2>
      </AppRow>
      <AppRow className="mt-7">
        <AppCol md={{ offset: 4 }}>
          <AppRow>
            <EmailUpdate readOnly={readOnly}/>
          </AppRow>
          <AppRow className="mt-7">
            <MobileUpdate readOnly={readOnly}/>
          </AppRow>
          <AppRow className="mt-7">
            <PasswordUpdate/>
          </AppRow>
        </AppCol>
      </AppRow>
    </>
  );
};

export default InfoConnexion;